import { ShieldCheckIcon, type LucideIcon } from 'lucide-react';

export interface AppIdentity {
  name: string;
  description: string;
  icon: LucideIcon;
}

/**
 * Asset & issue reporting platform identity.
 */
export const appIdentity: AppIdentity = {
  name: 'Fix It Foundry',
  description: 'Report, track, and resolve issues on physical assets — for councils, farms, workplaces, and your own home or rentals.',
  icon: ShieldCheckIcon
};
